import { render, staticRenderFns } from "./Single.vue?vue&type=template&id=a9a8aaa2&scoped=true&"
import script from "./Single.vue?vue&type=script&lang=js&"
export * from "./Single.vue?vue&type=script&lang=js&"
import style0 from "./Single.vue?vue&type=style&index=0&id=a9a8aaa2&prod&lang=scss&scoped=true&"
import style1 from "./Single.vue?vue&type=style&index=1&id=a9a8aaa2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9a8aaa2",
  null
  
)

export default component.exports